import React, { FC } from "react";
import { IFormItem, ISelectOption } from "../Types";
import { Form, Select } from "antd";

export const __FormSelect: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <Select
                mode={props.mode}
                allowClear={props.allowClear}
                options={props.options}
                disabled={props.disable}
                onChange={(value: string, option) => {
                    // debugger;
                    props.onSelectChange?.(value, option as ISelectOption)}}
            />
        </Form.Item>
    )
}